import React, { Component } from 'react';
import { connect } from 'dva';
import Container from '@/components/Container';
import Iframe from '@/components/Iframe';
import { RDP_PUBLIC_URL } from '@/utils/utils';

@connect(({ user }) => ({
  ...user,
}))
class Report extends Component {
  render() {
    const { orgId, enOrgType } = this.props.currentUser;

    if (!orgId) {
      return null
    }

    const searchType = enOrgType === "general_school" ? 'school' : 'bureau';
    const IframeDom = Iframe({
      src: `${RDP_PUBLIC_URL}/de9cb9a5ad045d3358ede9adc6d13ba9?checkType=&orgId=${orgId}&searchType=${searchType}`,
    });

    return (
      <Container breStates>
        <IframeDom />
      </Container>
    );
  }
}

export default Report;
